import { effect, signal } from '@preact/signals';
import { readJson, writeJson } from './storage';

const KEY = 'ct:collapsedOperators:v1';

/** Operators whose log groups are collapsed (shared by the sidebar and the Home list). */
export const collapsedOperators = signal<Set<string>>(new Set(readJson<string[]>(KEY, [])));

effect(() => writeJson(KEY, [...collapsedOperators.value]));

export function toggleOperator(op: string): void {
  const next = new Set(collapsedOperators.value);
  if (next.has(op)) next.delete(op);
  else next.add(op);
  collapsedOperators.value = next;
}

export function setAllOperators(ops: string[], collapsed: boolean): void {
  collapsedOperators.value = collapsed ? new Set(ops) : new Set();
}

export function expandOperator(op: string): void {
  if (!collapsedOperators.value.has(op)) return;
  const next = new Set(collapsedOperators.value);
  next.delete(op);
  collapsedOperators.value = next;
}
